var __TEMP__ = require('./_WeakMap.js');var WeakMap = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = metaMap;
